// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_di-0";